import script from "./TheSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSchedule.vue?vue&type=script&setup=true&lang=js"

import "./TheSchedule.vue?vue&type=style&index=0&id=42f49182&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f49182"]])

export default __exports__